module.exports = __webpack_public_path__ + "static/media/ic_youtube.6021397a.svg";